import { Button } from "Components/ui/button";
import OTPInput from "react-otp-input";
import { useNavigate, useSearchParams } from "react-router-dom";
import AuthCard from "../../Components/AuthCard/AuthCard";
import AuthLayout from "../../Components/AuthLayout/AuthLayout";
import { useEffect, useState } from "react";
import "./OtpVerification.scss";
import { useAuth, useSignUp } from "@clerk/clerk-react";
import { toast } from "sonner";
import { useDispatch } from "react-redux";
import { createChallenge } from "../../Redux/ChallengeSetup/ChallengeSetupAction";
function OtpVerification() {
  const { isLoaded, signUp } = useSignUp();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [timing, setTiming] = useState(30);
  const dispatch = useDispatch();
  const { getToken } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isLoaded) {
      try {
        setLoading(true);

        const verification = await signUp.attemptEmailAddressVerification({
          code: otp, // OTP entered by the user
        });

        if (verification.status === "complete") {
          setTimeout(() => {
            window.location.href = "/";
          setLoading(false);
            
          }, 5000);
        } else {
          setError("Invalid OTP");
          setLoading(false);
        }
      } catch (e) {
        setLoading(false);
        setError(e);
      }
    }
  };

  const navigate = useNavigate();

  const [otp, setOtp] = useState("");

  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (timing > 0) {
      setTimeout(() => {
        setTiming(timing - 1);
      }, 1000);
    }
  }, [timing]);
  const resendCode = async () => {
    try {
      await signUp.prepareEmailAddressVerification({
        strategy: "email_code",
      });
      setTiming(30);
    } catch (e) {
      setError(e);
    }
  };

  useEffect(() => {
    if (error) {
      toast.error(error.message, {
        autoClose: 2000,
        className: "bg-red-opacity text-red",
      });
    }
  }, [error]);

  return (
    <AuthLayout>
      <div className="flex justify-center items-center h-screen">
        <div className="mt-[45vh] translate-y-[-50%] h-[60vh] flex flex-col w-full max-w-[30rem]">
          <div className="text-2xl font-N_Medium">Verify your email</div>
          <div className="text-sm mb-[2rem] font-N_Roman text-white-FOREGROUND">
            Enter the 6-digit code sent to {searchParams.get("email")}
          </div>
          <form
            className="flex flex-col gap-6"
            onSubmit={(e) => handleSubmit(e)}
          >
            <div className="input_otp_div">
              <OTPInput
                value={otp}
                onChange={setOtp}
                numInputs={6}
                renderInput={(props) => <input {...props} />}
                containerStyle={{
                  justifyContent: "space-between",
                  gap: "1rem",
                }}
                inputStyle={{
                  width: "20%",
                  aspectRatio: "1/1",
                  height: "auto",
                  fontSize: "1.5rem",
                  borderRadius: "1rem",
                  border: "1px solid var(--grey)",
                  background: "transparent",
                }}
                shouldAutoFocus
              />
            </div>

            <Button
              type="submit"
              className="p-[1.3rem]"
              disabled={loading || !isLoaded}
            >
              {loading ? "Verifying" : "Verify"}
            </Button>
            <div
              className="w-fit mx-auto text-center text-primary text-sm mt-[1rem] font-N_Medium hover:underline cursor-pointer"
              onClick={() => navigate("/auth/login?tab=Register")}
            >
              Back
            </div>
            <div className="text-center text-grey text-sm mt-[1rem]">
              Didn't receive the code?
              <span
                className="ml-1 text-primary hover:underline cursor-pointer font-N_Medium"
                style={{
                  color: `${timing == 0 ? "var(--primary)" : "var(--grey)"}`,
                  pointerEvents: `${timing == 0 ? "all" : "none"}`,
                }}
                onClick={() => {
                  if (timing == 0) {
                    resendCode();
                  }
                }}
              >
                {timing == 0
                  ? "Resend Code"
                  : `Resend Code in ${timing} seconds`}
              </span>
            </div>
          </form>
        </div>
      </div>
    </AuthLayout>
  );
}

export default OtpVerification;
